(() => {
	angular.module('main').controller('CalendarController', CalendarController);
	CalendarController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$q',
		'$filter',
		'$routeParams',
		'appointmentService',
		'calendarEventsDataService',
		'extraShootService',
		'jobDataService',
		'messageService',
		'timeService',
		'workflowService',
		'workflowDataService',
		'jobTypesDataService',
		'calendarService',
		'settingsService',
		'utilsService'
	];

	function CalendarController(
		$scope,
		$rootScope,
		$location,
		$q,
		$filter,
		$routeParams,
		appointmentService,
		calendarEventsDataService,
		extraShootService,
		jobDataService,
		messageService,
		timeService,
		workflowService,
		workflowDataService,
		jobTypesDataService,
		calendarService,
		settingsService,
		utilsService
	) {
		$scope.$on('$viewContentLoaded', () => {
			settingsService.timeFormatSettings.subscribe(data => {
				if (data.weekStartsOn !== null) {
					$scope.is12TimeFormat = data.timeFormat === 'T_12';
					$scope.weekStartsOn = angular.copy(data.weekStartsOn);
					$scope.timeFormat = $scope.is12TimeFormat ? 'h:mm a' : 'HH:mm';
					bootstrapCalendar();
				}
			});
			$scope.unsubscribe = new Rx.Subject();
			subscribeToCustomizeLabelsChange();
		});

		$scope.$on('$destroy', () => {
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
		});

		function subscribeToCustomizeLabelsChange() {
			settingsService.customizeLabelsObservable
				.takeUntil($scope.unsubscribe)
				.subscribe(customizeLabels => {
					$scope.mainShootLabelName = customizeLabels.mainShootLabel;
					$scope.extraShootLabelName = customizeLabels.extraShootLabel;
					$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
					$scope.businessNumberLabelName = customizeLabels.businessNumberLabel;
				});
		}
		function bootstrapCalendar() {
			setWeekDays();
			$scope.equals = angular.equals;
			$scope.date = new Date().getTime();

			$scope.now = new Date();
			$scope.now.setHours(12, 0, 0, 0);

			$scope.isAddNewSpinnningWheelActive = false;

			if (!$scope.calendarCurrent) {
				$scope.calendarCurrent = new Date($scope.now);
			}

			if ($routeParams.calendarView) {
				$scope.month = $routeParams.calendarView !== 'week';
			} else {
				$scope.month = true;
			}

			if ($routeParams.eventId) {
				$scope.eventIdToOpen = $routeParams.eventId;
			}

			$scope.changeView =
				$routeParams.calendarView !== 'week' ? 'Month' : 'Week';

			$scope.getCalendarView();

			$scope.hours = [];
			$scope.activeJobs = [];
			$scope.workflowNames = [];
			$scope.jobTypes = [];
			$scope.isDisabled = false;
			const timeSeparatorShow = new Date($scope.now);
			timeSeparatorShow.setHours(6, 0, 0, 0);
			$scope.timeSeparatorShow = timeSeparatorShow;

			for (let i = 0; i <= 23; i++) {
				const time = new Date($scope.now);
				time.setHours(i, 0, 0, 0);
				$scope.hours.push(time);
			}
		}

		function setWeekDays() {
			$scope.fullDaysOfWeek = [
				'Monday',
				'Tuesday',
				'Wednesday',
				'Thursday',
				'Friday',
				'Saturday',
				'Sunday'
			];
			$scope.daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
			$scope.helpArray = [1, 2, 3, 4, 5, 6, 0];
			$scope.startDay = 1;
			$scope.endDay = 0;
			$scope.weekOffset = 1;

			switch ($scope.weekStartsOn) {
				case 'SATURDAY':
					modifyWeekArrays(2);
					$scope.helpArray = [6, 0, 1, 2, 3, 4, 5];
					$scope.startDay = 6;
					$scope.endDay = 5;
					$scope.weekOffset = -1;
					break;
				case 'SUNDAY':
					modifyWeekArrays(1);
					$scope.helpArray = [0, 1, 2, 3, 4, 5, 6];
					$scope.startDay = 0;
					$scope.endDay = 6;
					$scope.weekOffset = 0;
					break;
				default:
					break;
			}

			$scope.open = function($event) {
				$event.preventDefault();
				$scope.opened = true;
			};
			$scope.status = {
				opened: false
			};
		}

		function modifyWeekArrays(quantity) {
			let rightPart = $scope.fullDaysOfWeek.splice(
				$scope.fullDaysOfWeek.length - quantity,
				$scope.fullDaysOfWeek.length
			);
			$scope.fullDaysOfWeek.unshift(...rightPart);

			rightPart = $scope.daysOfWeek.splice(
				$scope.daysOfWeek.length - quantity,
				$scope.daysOfWeek.length
			);
			$scope.daysOfWeek.unshift(...rightPart);
		}

		let isBlockRequest = false;

		$scope.timeSeparatorShow = true;

		$scope.toggleHidenHours = function() {
			$scope.timeSeparatorShow = !$scope.timeSeparatorShow;
		};

		$scope.jump = function(step) {
			const isToday = !step;
			getView(isToday, step);
		};

		$scope.selectMonth = function() {
			getView();
		};

		$scope.filters = [
			{
				name: 'leads',
				change: true,
				criteria: {
					column: 'inLead',
					value: true
				}
			},
			{
				name: 'jobs',
				change: true,
				criteria: {
					column: 'inLead',
					value: false
				}
			}
		];

		// filter for appointment who has no jobs and leads
		const defaultFilter = [
			{
				name: 'Default filter',
				change: true,
				criteria: {
					column: 'inLead',
					value: null
				}
			}
		];

		$scope.changeCheckboxFilters = () => {
			const events = eventsFilter($scope.allEvents);
			if ($routeParams.calendarView !== 'week') {
				showBlancCalendar();
				fillMonthEvents(events);
			} else {
				showBlancWeekCalendar();
				fillWeekEvents(events);
			}
		};

		function eventsFilter(events) {
			const filters = $scope.filters.concat(defaultFilter);

			const newArr = [];

			events.forEach(event => {
				for (let i = 0; i < filters.length; i++) {
					if (!filters[i].change) {
						continue;
					}
					if (event[filters[i].criteria.column] === filters[i].criteria.value) {
						newArr.push(event);
						break;
					}
				}
			});

			return newArr;
		}

		$scope.changeViewSelect = () => {
			$scope.toggleView($scope.changeView);
		};

		$scope.toggleView = view => {
			$scope.month = !(view == 'Week');
			view === 'Week' ? getView(false, 0, null, true) : getView(false, 0);
		};

		const fillMonthEvents = function(events) {
			events = fillCalendarFilter(events);

			$scope.dates.forEach(day => {
				events.forEach(event => {
					const iterationEvent = angular.copy(event);
					if (calendarService.isCorrectDate(iterationEvent, day)) {
						day.events.push(iterationEvent);
					}
				});
				if (day.events.length >= 2) {
					day.events = day.events.sort(sortByDateTime);
				}
			});

			checkIfNeedToOpenEvent(events);
		};

		const fillWeekEvents = function(events) {
			events = fillCalendarFilter(events);

			$scope.week.forEach(day => {
				events.forEach(event => {
					const iterationEvent = angular.copy(event);

					if (calendarService.isCorrectDate(iterationEvent, day)) {
						if (!iterationEvent.startTime) {
							day.allDayEvents.push(iterationEvent);
						} else {
							fillWeekHours(iterationEvent, day.hours);
						}
					}
				});
			});

			checkIfNeedToOpenEvent(events);
		};

		function getEvents(start, end, callback) {
			const format = 'yyyy-MM-dd';
			isBlockRequest = true;

			calendarEventsDataService
				.getEventsForPage(start, end, format)
				.finally(() => (isBlockRequest = false))
				.subscribe(
					data => {
						$scope.allEvents = data;
						const events = eventsFilter($scope.allEvents);
						callback(events);
					},
					error => messageService.showDefaultErrorMessage(error)
				);
		}

		$scope.getCalendarView = function() {
			if ($routeParams.calendarDate && Date.parse($routeParams.calendarDate)) {
				getView(false, 0, $routeParams.calendarDate);
			} else {
				getView(false, 0);
			}
		};

		function showGeneralErrorMessage() {
			messageService.showToaster('e_0', 'general');
		}

		function getView(today, step, calendarDate, resetWeek) {
			if (isBlockRequest) {
				return false;
			}
			if (calendarDate) {
				$scope.calendarCurrent = new Date(calendarDate);
			} else if (!step && today) {
				$scope.calendarCurrent = new Date($scope.now);
			} else if (!step && !today) {
				$scope.calendarCurrent = new Date($scope.calendarCurrent);
			} else if ($scope.month) {
				const y = $scope.calendarCurrent.getFullYear();
				const m = $scope.calendarCurrent.getMonth();

				const firstDay = new Date(y, m, 1, 12);

				$scope.first = firstDay;
				$scope.calendarCurrent = new Date(firstDay);
				$scope.calendarCurrent.setMonth(
					$scope.calendarCurrent.getMonth() + step
				);
			}

			if ($scope.month) {
				handleMonthView();
			} else {
				handleWeekView(today, step, resetWeek);
			}

			$location.search('calendarView', $scope.month ? 'month' : 'week');
			$location
				.search('calendarDate', $scope.calendarCurrent.toISOString())
				.replace();
		}

		function handleMonthView() {
			let y, m;

			$scope.first = new Date($scope.calendarCurrent);
			$scope.selected = {};

			y = $scope.calendarCurrent.getFullYear();
			m = $scope.calendarCurrent.getMonth();

			const firstDay = new Date(y, m, 1, 12);
			const lastDay = new Date(y, m + 1, 0, 12);

			$scope.first = firstDay;

			if ($scope.first.getDay() != $scope.startDay) {
				$scope.first.setDate(
					$scope.first.getDate() -
						$scope.helpArray.findIndex(d => d === $scope.first.getDay())
				);
			}
			$scope.last = angular.copy(lastDay);

			if ($scope.last.getDay() != $scope.endDay) {
				$scope.last.setDate(
					$scope.last.getDate() +
						(6 - $scope.helpArray.findIndex(d => d === $scope.last.getDay()))
				);
			}

			showBlancCalendar();
			getEvents($scope.first, $scope.last, fillMonthEvents);
		}

		function handleWeekView(today, direction, resetWeek) {
			if (!$rootScope.weekFirst || resetWeek) {
				$rootScope.weekFirst = angular.copy($scope.calendarCurrent);
			} else if (today) {
				$scope.calendarCurrent = new Date($scope.now);
				$rootScope.weekFirst = angular.copy($scope.calendarCurrent);
			}

			if ($rootScope.weekFirst.getDay() != $scope.startDay) {
				let val = $rootScope.weekFirst.getDate();

				if (direction > 0) {
					val += 7 - $rootScope.weekFirst.getDay();
				} else {
					val -= $rootScope.weekFirst.getDay();
				}

				$rootScope.weekFirst.setDate(val + $scope.weekOffset);
			} else if (direction) {
				const offset = direction > 0 ? 7 : '-7';

				$rootScope.weekFirst.setDate($rootScope.weekFirst.getDate() + +offset);
				$scope.calendarCurrent = angular.copy($rootScope.weekFirst);
			}

			$scope.weekLast = angular.copy($rootScope.weekFirst);
			$scope.weekLast.setDate($scope.weekLast.getDate() + 6);

			showBlancWeekCalendar();
			getEvents($rootScope.weekFirst, $scope.weekLast, fillWeekEvents);
		}

		function showBlancCalendar() {
			$scope.weeks = [];
			$scope.dates = [];

			const iterationDate = angular.copy($scope.first);
			let index = 0;
			let indexY = -1;
			while (iterationDate.getTime() <= $scope.last.getTime()) {
				const dayDate = new Date(iterationDate);
				const day = {
					year: dayDate.getFullYear(),
					month: dayDate.getMonth(),
					day: dayDate.getDate(),
					date: dayDate,
					events: []
				};
				$scope.dates.push(day);

				if (index == 0) {
					indexY++;
					$scope.weeks[indexY] = [];
					$scope.weeks[indexY].push(day);
					index++;
				} else if (index == 6) {
					index = 0;
					$scope.weeks[indexY].push(day);
				} else {
					$scope.weeks[indexY].push(day);
					index++;
				}
				iterationDate.setDate(iterationDate.getDate() + 1);
			}
		}

		function showBlancWeekCalendar() {
			$scope.week = [];
			$scope.weekDates = [];
			const iterationDate = angular.copy($rootScope.weekFirst);
			const index = 0;
			const indexY = -1;
			while (iterationDate.getTime() <= $scope.weekLast.getTime()) {
				const dayDate = new Date(iterationDate);

				const day = {
					year: dayDate.getFullYear(),
					month: dayDate.getMonth(),
					day: dayDate.getDate(),
					date: dayDate,
					hours: [],
					allDayEvents: []
				};

				for (let i = 0; i <= 23; i++) {
					const time = new Date(iterationDate);
					time.setHours(i, 0, 0, 0);

					const hour = {
						time,
						events: []
					};
					day.hours.push(hour);
				}
				$scope.week.push(day);
				$scope.weekDates.push(day);
				const event = null;

				iterationDate.setDate(iterationDate.getDate() + 1);
			}
		}

		function fillCalendarFilter(eventsData) {
			let data = angular.copy(eventsData);

			data = $filter('orderBy')(
				data,
				value => {
					value.startTime != null ? timeService.getHour(value.startTime) : 1000;
				},
				false
			);
			return data;
		}

		// fix this code by ESlint rules (no-confusing-arrow)
		function fillWeekHours(event, hours) {
			hours.forEach(hour => {
				if (calendarService.isCorrectHours(event, hour.time)) {
					hour.events.push(event);
				}
			});
		}

		$scope.noCurrentDate = (firstDate, secondDate) =>
			calendarService.noCurrentDate(firstDate, secondDate);

		// new event

		$scope.addNew = function() {
			$scope.selected = {};
			$('#addNewModal').modal('show');
		};

		$scope.newEvent = function(date, time) {
			let startTime = null;
			let endTime = null;
			let endTimeHours;

			if (time && time != null) {
				startTime = new Date(time);
				endTime = angular.copy(startTime);

				endTime.setHours(startTime.getHours() + 1);
				endTimeHours = startTime.getHours() + 1;

				if (!$scope.is12TimeFormat && startTime.getHours() === 23) {
					endTimeHours = 0;
				}

				startTime = $scope.is12TimeFormat
					? timeService.convertDateTo12(startTime)
					: `${startTime.getHours()}:0${startTime.getMinutes()}`;
				endTime = $scope.is12TimeFormat
					? timeService.convertDateTo12(endTime)
					: `${endTimeHours}:0${endTime.getMinutes()}`;
			}

			$scope.selected = {
				date,
				startTime,
				endTime
			};

			$('#addNewModal').modal('show');
		};

		function addEventWithDateTime(dateTime) {
			return {
				id: null,
				name: '',
				startDate: dateTime.date,
				endDate: dateTime.date,
				startTime: dateTime.startTime,
				endTime: dateTime.endTime
			};
		}

		function chooseEventModal(event) {
			if (event && event.calendarEventType === 'APPOINTMENT') {
				appointmentService
					.prepareAppointmentToShow(event)
					.subscribe(appointment => {
						workflowService.setTaskInfo(appointment);
						$('#appointment').modal('show');
					});
			} else if (event && event.calendarEventType === 'EXTRA_SHOOT') {
				const extraShoot = extraShootService.prepareExtraShootToShow(event);
				workflowService.setTaskInfo(extraShoot);
				$('#extraShootModal').modal('show');
			} else {
				workflowService.setTaskInfo({});
				$('#appointment').modal('show');
			}
		}

		$scope.editEventModal = function(event, $event) {
			if ($event && $event.stopPropagation) {
				$event.stopPropagation();
			}
			if (event && event.calendarEventType === 'MAIN_SHOOT') {
				return;
			}
			getActiveJobs().then(() => {
				chooseEventModal(event);
			});
		};

		// add new job
		function getJobTypes() {
			return jobTypesDataService
				.getJobTypes()
				.map(data => successGetJobTypes(data));
		}

		function successGetJobTypes(data) {
			$scope.newJob.jobTypes = angular.copy(data);
		}

		function getWorkflowAndLanguageNames() {
			return workflowDataService
				.getWorkflowAndLanguageNames()
				.map(data => successGetWorkflowAndLanguageNames(data));
		}

		function successGetWorkflowAndLanguageNames(data) {
			if (!data) {
				return false;
			}
			$scope.newJob.workflowNames = angular.copy(data.workflows);
			$scope.newJob.languageNames = angular.copy(data.languages);
		}

		function showNewJobModal(event) {
			const selectModal = '#addNewModal',
				nextModal = '#newJob';
			$scope.button_disable = false;
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.$broadcast('showModalJob', $scope.newJob);
		}

		function showNewLeadModal(event) {
			const selectModal = '#addNewModal',
				nextModal = '#newLead';
			$scope.button_disable = false;
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.$broadcast('showModal', {
				lead: $scope.newJob
			});
		}

		$scope.showAddNewJobModal = event => {
			$scope.button_disabled = true;
			$scope.isDisabled = true;
			$scope.isAddNewSpinnningWheelActive = true;

			if ($scope.selected && $scope.selected.date) {
				$scope.newJob = addJobWithDateTime($scope.selected);
			} else {
				$scope.newJob = {};
			}

			$scope.clients = [];

			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames())
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.button_disable = false;
					$scope.isDisabled = false;
					$scope.isAddNewSpinnningWheelActive = false;
				})
				.subscribe(() => {
					$scope.newJob.type = $scope.jobTypes[0];
					showNewJobModal(event);
				});
		};

		$scope.showAddNewLeadModal = event => {
			$scope.button_disabled = true;
			$scope.isDisabled = true;
			$scope.isAddNewSpinnningWheelActive = true;

			if ($scope.selected && $scope.selected.date) {
				$scope.newJob = addJobWithDateTime($scope.selected);
			} else {
				$scope.newJob = {};
			}

			$scope.clients = [];

			Rx.Observable.zip(getJobTypes(), getWorkflowAndLanguageNames())
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.button_disable = false;
					$scope.isDisabled = false;
					$scope.isAddNewSpinnningWheelActive = false;
				})
				.subscribe(() => {
					$scope.newJob.type = $scope.jobTypes[0];
					showNewLeadModal(event);
				});
		};

		function addJobWithDateTime(dateTime) {
			return {
				finishDate: dateTime.date || null,
				startDate: dateTime.date || null,
				startTime: dateTime.startTime || null,
				finishTime: dateTime.endTime || null
			};
		}

		// extra shoots

		$scope.showAddExtraShootModal = event => {
			$scope.button_disable = true;
			event.preventDefault();

			$('#addNewModal')
				.modal('hide')
				.on('hidden.bs.modal', function() {
					getActiveJobs().then(() => {
						addNewExtraShoot();
						$scope.button_disable = false;
						$('#extraShootModal').modal('show');
						$(this).off('hidden.bs.modal');
					});
				});
		};

		function addNewExtraShoot() {
			if ($scope.selected && $scope.selected.date) {
				const extraShoot = addEventWithDateTime($scope.selected);
				workflowService.setTaskInfo(extraShoot);
				if (!$scope.$$phase) {
					$scope.$apply();
				}
			} else {
				workflowService.setTaskInfo({});
				$scope.$evalAsync();
			}
		}

		// appointments

		$scope.showAppointmentModal = function(event) {
			$scope.button_disable = true;
			event.preventDefault();

			$('#addNewModal')
				.modal('hide')
				.on('hidden.bs.modal', function() {
					getActiveJobs().then(() => {
						addNewAppointment();
						$scope.button_disable = false;
						$('#appointment').modal('show');
						$(this).off('hidden.bs.modal');
					});
				});
		};

		function addNewAppointment() {
			if ($scope.selected && $scope.selected.date) {
				const appointment = addEventWithDateTime($scope.selected);
				workflowService.setTaskInfo(appointment);
				if (!$scope.$$phase) {
					$scope.$apply();
				}
			} else {
				workflowService.setTaskInfo({});
				$scope.$evalAsync();
			}
		}

		function getActiveJobs() {
			const deferred = $q.defer();

			if (!$scope.activeJobs.length) {
				jobDataService
					.getActiveJobs()
					.then(jobs => {
						$scope.activeJobs = jobs;
						deferred.resolve(jobs);
					})
					.catch(messageService.showDefaultErrorMessage);
			} else {
				deferred.resolve($scope.activeJobs);
			}

			return deferred.promise;
		}

		function sortByDateTime(a, b) {
			if (
				timeService.convertTimeToSeconds(a.startTime) <
				timeService.convertTimeToSeconds(b.startTime)
			) {
				return -1;
			}
			return 1;
		}

		function checkIfNeedToOpenEvent(events) {
			if ($scope.eventIdToOpen) {
				const [event] = events.filter(
					e => e.id.toString() === $scope.eventIdToOpen
				);

				if (event) {
					chooseEventModal(event);
				}

				$scope.eventIdToOpen = false;
			}
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/calendarController.js